import { render, staticRenderFns } from "./counter.vue?vue&type=template&id=57f05e34&scoped=true&"
import script from "./counter.vue?vue&type=script&lang=js&"
export * from "./counter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f05e34",
  null
  
)

export default component.exports